/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../../lib/@waca/core-client/js/core-client/ui/core/View',
	'react',
	'react-dom',
	'./ServiceabilityContent',
	'jquery'
], function(
	View,
	React,
	ReactDOM,
	Content
) {
	/**
	 * This is a wrapper class of the react components inside the glass slideout.
	 */
	class ServiceabilityView extends View{
		constructor(option){
			super(option);
			this._widgetInfo = option.widgetInfo;
			this._dashboardApi = option.dashboardApi;
			this._closePanel = option.closePanel;
		}

		render(){
			return new Promise((resolve) => {
				ReactDOM.render(
					<Content
						widgetInfo={this._widgetInfo}
						dashboardApi={this._dashboardApi}
						UISpec={this._widgetInfo.toUIJSON()}
						showButtons={true}
						closePanel={this._closePanel}
					/>,
					this.el,
					() => {resolve();}
				);
			});
		}

		remove(){
			ReactDOM.unmountComponentAtNode(this.el);
		}

		getDOMInfo(){
			let DOMInfo = {};
			let $widgetIDValue = this.$el.find('.widgetID_valueArea');
			if($widgetIDValue.length >= 1){
				DOMInfo.id = $widgetIDValue[0].innerText;
			}
			return DOMInfo;
		}
	}

	return ServiceabilityView;
});
